<template>
    <div class="all">
        <div v-loading="dataLoading" class="warp">
            <div class="warp-body">
                <div class="firle clearfix">
                    <h2 class="">我的收藏</h2>
                    <div class="mt20">
                        <label class="checkbox-box tion">
                            <label class="checkbox-warp fl" :class="ids.length === pageUuid.length && ids.length > 0 ? 'curr' : ''">
                                <input class="checkbox" name="selectAll" @click="checkAll($event)" :checked="ids.length === pageUuid.length && ids.length > 0 ? true : false" type="checkbox" value="">
                                <i class="icons checkbox-icon"></i>
                            </label>
                            全选
                        </label>
                        <span class="checkbox-box cp tion" @click="cancelCollect();">批量取消收藏</span>
                        <span class="checkbox-box cp tion" @click="downLoad(0);" title="下载当前所选数据">批量下载</span>
                        <span class="checkbox-box cp tion" v-if="list.length>0" @click="downLoad(1);" title="下载当前方案的所有数据">全部下载</span>
                    </div>
                </div>
                <div class="no-data" v-if="nodata"><span class="text">没有数据哦...</span></div>
                <ul class="article-list" style="min-height: 400px;">
                    <li v-for="(item,index) in list" :key="index">
                        <div class="article-left fl">
                            <label class="checkbox-warp" :class="ids.indexOf(item.typeId) != -1 ? 'curr' : ''">
                                <input class="checkbox" v-model="ids" type="checkbox" name="chooseInfo" :value="item.typeId">
                                <i class="icons checkbox-icon"></i>
                            </label>
                        </div>
                        <div class="article-right fr">
                            <div class="article-btn">
                                <a class="color-orange" href="javascript:void(0);" @click="cancelCollect(item.typeId,item.type)">取消收藏</a>
                            </div>
                        </div>
                        <div class="article-mid">
                            <a class="color-3d3d4c" href="javascript:void(0);" @click="newsJump(item.typeId,item.newsSimHash,item.isEffective,item.typefrom,item.type,item.newsIsRead);">
                                <h2 class="article-title ovhidden2" :style="{ color: item.newsIsRead ? $newsIsRead : '' }" v-html="item.title"></h2>
                                <p class="mt5 color-8a8a99 ovhidden2">{{item.summary}}</p>
                                <!----{{item.newsIsRead}}-->
                                <p class="ziduan color-8a8a99 mt10">
                                    <span>发布时间：{{item.publishTime}}</span>
                                    <span>发布人：<i class="icons sm-icon" :class="icons[item.sourceType]"></i>{{item.source}}</span>
                                </p>
                            </a>
                        </div>
                    </li>
                </ul>
                <!-- 分页 -->
                <page class="mt20" v-if="totalCount != ''" :currentPage.sync="page" :limit.sync="limit" :totalCount="totalCount"  @turn="getTableData"></page>
            </div>
        </div>
	</div>
</template>
<script>
import page from '../../components/page.vue';
export default {
    components: {page},
    data() {
        return {
            pageUuid:[],//单分页所有的uuid
            icons:{
                'wx':'wx-icon',
                'web':'web-icon1',
                'weibo':'wb-icon1',
                'app':'app-icon1',
                'bbs':'bbs-icon1',
                'journal':'bk-icon1',
                'media_toutiao':'tt-icon1',
                'media_qq':'qq-icon1',
                'media_baijia':'bj-icon1',
                'media_sohu':'sh-icon1',
                'media_wangyi':'wy-icon1',
                'media_people':'people-icon1'
            },
            ids:[],//选择的uuid数组
            page:1,
            nodata:'',
		    limit:20,//每页显示条数
            totalCount:'',//总页数
          dataLoading: false,
            list:[]//列表
        }
    },
    mounted() {
		let that = this;
        that.$nextTick(()=> {
            that.getCollectList();
        })

    },
    created() {

    },
    methods: {
        //下载
        downLoad(type){
            let that = this;
            let newsId = [];
            if(this.ids.length <= 0&&type == 0){
                that.$utils.alertText('您未选择任何新闻');
                return;
            }
            for(let item of this.ids){
                for(let child of this.list){
                    if(item == child.typeId){
                        newsId.push(child.id)
                    }
                }
            }
            let data = {
                typefrom:'collection',
                collectionIds:type == 0 ? newsId:'',
                allCollection:type,
                type:'11'
            }
            that.$parent.loadModal(true,'正在提交数据...');
            that.$api.post('scheme/info/download', data, r => {
                that.$utils.returnCode(r,function(){
                    that.$parent.showLoad = false;
                    that.$parent.alertTips('已添加到我的下载列表');
                },function(){
                    that.$parent.showLoad = false;
                });
            })
        },
		// 获取收藏列表
        getCollectList (type) {
            let that = this;
            that.ids = [];
            if(type === 0){
               that.page = 1;
            }
            $(".warp .checkbox-warp").removeClass('curr');
            $(".warp input:checkbox[name='selectAll']").prop("checked",false);
            this.dataLoading = true
            that.$api.get('user/index/collection-records',{page:that.page,perpage:that.limit},r =>{
                that.$utils.returnCode(r,()=>{
                  that.dataLoading = false;
                  that.$set(that,'list',r.data.list)
                    if(r.data.list.length <= 0){//没有数据
                        that.nodata = true;
                        return;
                    }else{
                        that.nodata = false;
                    }
                    that.totalCount = r.data.total;
                    let pageUuid = [];
                    for(let i of r.data.list){
                        pageUuid.push(i.typeId);
                    }
                    that.pageUuid = pageUuid;
                })
            })
        },
        //新闻详情跳转
        newsJump (id,newsSimHash,type,typefrom,articleType) {
			this.list.forEach(it=>{
				if(it.typeId == id)it.newsIsRead = 1
			})
            if(type === 2){//过期无法跳转
                this.$utils.alertText('收藏文章已失效');
            }else{
                 let startDate = this.$utils.getNowDate();//今天时间
                let endDate = this.$utils.getBeforeDay(this.startDate,7,1);//前一天
                let data = id + ',' + newsSimHash + ',' + startDate + ',' + endDate;
                let routeData;
                if(typefrom === 'monitor'){
                    routeData = this.$router.resolve({path:'/monitoringDet',query:{data:data}})
                    window.open(routeData.href, '_blank');
                }else if(typefrom === 'event') {
                    routeData = this.$router.resolve({path:'/detailInformation',query:{data:data}})
                    window.open(routeData.href, '_blank');
                }else{
                    if(articleType =='1'){
                        routeData = this.$router.resolve({path:'/detail',query:{data:data}})
                        window.open(routeData.href, '_blank');
                    }else if(articleType =='2'){
                        window.open(window.location.protocol+'//'+ window.location.host+'/nindex/publicSentiment/detail?data='+id+','+newsSimHash+',,,,1,,,&type='+articleType, '_blank');
                    }else{
                        window.open(window.location.protocol+'//'+ window.location.host+'/nindex/publicSentiment/videoDetail?data='+id+','+newsSimHash+',,,,1,,,}', '_blank');
                    }
                }
            }
        },
        // 全选状态
        checkAll (e) {
            let that = this;
            let checked = e.target.checked;
            that.ids = [];
            if(checked == true){
                that.ids = that.pageUuid;//全选的时候 获取所有的uuid
            }else{
                that.ids = [];
            }
        },
        // 翻页
        getTableData () {
            let that = this;
            that.getCollectList();
        },
        // 取消收藏
        cancelCollect (id,type) {
            let that = this;
            let ids = '';
            let data1={
                    typeId:[],
                    type:1
                };
            let data2={
                typeId:[],
                type:2
            };
            let data3={
                typeId:[],
                type:3
            };
            if(id === undefined){//批量预警
                ids = that.ids;
                if(ids.length <= 0){
                    that.$utils.alertText('您未选择任何新闻');
                    return;
                }
                for(let itsems of this.list){
                    if(this.ids.indexOf(itsems.typeId)>-1){
                        if(itsems.type == '1'){
                            data1.typeId.push(itsems.typeId);
                        }else if(itsems.type == '2'){
                            data2.typeId.push(itsems.typeId);
                        }else{
                            data3.typeId.push(itsems.typeId);
                        }
                    }
                }
            }else{
                ids = [id];
            }
            let datas = []
            if(id!=null){
                datas=[{
                    typeId:[id],
                    type:type
                }]
            }else{
                if(data1.typeId.length!==0){
                    datas.push(data1);
                }
                if(data2.typeId.length!==0){
                    datas.push(data2);
                }
                if(data3.typeId.length!==0){
                    datas.push(data3);
                }
            }
            that.$parent.loadModal(true,'正在提交数据...');
            that.$api.post('user/index/cancel-collect',{data:datas},r =>{
                that.$parent.showLoad = false;
                that.$utils.returnCode(r,function(){
                    that.getCollectList(0);
                })
            })
        }
	}
}
</script>



// WEBPACK FOOTER //
// src/page/personalCenter/myCollect.vue